/**
 * @generated SignedSource<<c2406f77d5c5642a09e2e9b2b1e9f076>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VotePowerRowFragment$data = {
  readonly tokensRepresented: {
    readonly bpsOfQuorum: number;
    readonly bpsOfTotal: number;
  };
  readonly " $fragmentType": "VotePowerRowFragment";
};
export type VotePowerRowFragment$key = {
  readonly " $data"?: VotePowerRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"VotePowerRowFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VotePowerRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VotingPower",
      "kind": "LinkedField",
      "name": "tokensRepresented",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bpsOfTotal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bpsOfQuorum",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Delegate",
  "abstractKey": null
};

(node as any).hash = "8d8b1bac8920315da83ad0bf86a404b6";

export default node;
